import type { TCorResponse } from '@/features/configuracoes/interfaces'
import { HttpService } from '@/shared/lib'

export class GetCoresService extends HttpService {
  async execute(idExterno: number) {
    return this.http.get<TCorResponse>(`api/v2/Empreendimento/${idExterno}/corDoLote`)
  }
}
